import { gql } from '@apollo/client';

import { VACANCY_CARD_FIELDS } from './fields';

const BASE_VACANCY_FIELDS = gql`
  fragment BaseVacancyFields on Vacancy {
    ageFrom
    ageTo
    activatable
    activationStatus
    approvedAt
    bumpedAt
    createdAt
    daysLeft
    deletable
    description
    education
    experience
    expirable
    hits
    id
    isBookmarked
    isBumped
    isFeatured
    isMine
    jobDescription
    location
    logo
    name
    positionName
    rejectReason
    email
    phones
    relatedAds {
      ... on Vacancy {
        ageFrom
        ageTo
        approvedAt
        bumpedAt
        createdAt
        daysLeft
        deletable
        description
        expirable
        hits
        id
        isBookmarked
        isBumped
        isFeatured
        isMine
        jobDescription
        location
        logo
        name
        positionName
        rejectReason
        requirements
        salaryFrom
        salaryTo
        status
        updatedAt
        profile {
          logoUrl
          name
        }
      }
    }
    requirements
    salaryFrom
    salaryTo
    status
    updatedAt
    vipAds {
      ... on Vacancy {
        ageFrom
        ageTo
        approvedAt
        bumpedAt
        createdAt
        daysLeft
        deletable
        description
        expirable
        hits
        id
        isBookmarked
        isBumped
        isFeatured
        isMine
        jobDescription
        location
        logo
        name
        positionName
        rejectReason
        requirements
        salaryFrom
        salaryTo
        status
        updatedAt
        profile {
          logoUrl
          name
        }
      }
    }
    responsibilities
    contactName
    category {
      id
      name
      parentId
    }
    profile {
      contactName
      description
      id
      logoUrl
      name
      publishedCount
      regionName
      specializationName
    }
  }
`;

// Query for a single vacancy by ID
export const GET_VACANCY_BY_ID = gql`
  ${BASE_VACANCY_FIELDS}

  query GetVacancy($id: ID!) {
    vacancy(id: $id) {
      ...BaseVacancyFields
    }
  }
`;

// Query for FEATURED vacancies
export const GET_MORE_FEATURED_VACANCIES = gql`
  ${VACANCY_CARD_FIELDS}

  query GetFeaturedVacancies {
    vacancies(scope: FEATURED, filter: { random: true }, first: 8) {
      edges {
        node {
          ...vacancyCardFields
        }
      }
    }
  }
`;
